<template>
  <FullPageLayout>
    <div
      v-if="isChaptaActive"
      id="verification-modal"
      class="invisible fixed inset-0 w-full h-full u-center bg-black-60 z-full-page-loading"
    >
      <div class="flex flex-col justify-center items-center w-96 bg-white rounded-lg px-6 py-12">
        <div class="text-center mb-6 font-semibold">Devam etmek için lütfen butona tıklayarak robot olmadığınızı doğrulayın.</div>
        <div id="cfct-container" class="w-[298px] h-[63px]"></div>
      </div>
    </div>
    <template #page__actions>
      <ArticleFavorite :article="shareArticle" />
      <ScrollToComments :article="shareArticle" />
      <ArticleShare :article="shareArticle" />
    </template>
    <template v-if="isOnedioVideo" #video__streaming__section>
      <AdController unit="masthead" class="bg-[#181819] u-center" />
      <VideoHero v-if="!isEmpty(article)" :article="article" />
    </template>
    <ArticleStatus v-if="isDraft" :text="$t('news-page.draft')" />
    <OBackButton is-article-page />
    <OArticleNavigator v-if="isMobile && IS_ONEDIO" />
    <ArticleIGWidget v-if="isIgWidgetActive" />
    <template v-if="fetchState.error">
      <ErrorPageLayout :error="fetchState.error" />
    </template>
    <div v-else class="mx-auto w-full mt-4 max-w-[1100px]">
      <AdController v-if="!isOnedioVideo" unit="masthead" />
      <div class="main bg-white relative">
        <div class="flex flex-row">
          <div class="sm:flex-shrink-0 w-full max-w-[715px] mr-0 sm:mr-10">
            <!--article-->
            <OArticle
              v-if="!isEmpty(article)"
              class="relative"
              :item="article"
              :hide="['shareCount', 'viewCount']"
              @oet-impression="sendOnedioEvent"
            ></OArticle>
            <LazyHydrate v-if="!isEmpty(article)" never>
              <TrackingCodes :item="article" />
            </LazyHydrate>
            <LazyHydrate v-if="hasFlag('showReactions')" :when-visible="{ rootMargin: '100px' }">
              <OArticleReactions class="mt-10 mb-6" :item="article"></OArticleReactions>
            </LazyHydrate>
            <ArticleAds v-if="!isMobile" unit-name="icerikArasiBottom" />
            <LazyHydrate v-if="hasFlag('showComments')" :when-visible="{ rootMargin: '300px' }">
              <OArticleComments :id="'reactions-' + article.legacyId" class="mb-10" :item="article"></OArticleComments>
            </LazyHydrate>
            <LatestWidget v-if="isMobile" :articles="sidebarRecommendations" class="px-4" />
            <!--taboola-->
            <div class="sm:px-0 px-4">
              <AdController v-if="stnData.length === 0" unit="articleTaboola" :is-stn-active="isStnActive" />
              <AdController
                v-else-if="stnPage < stnData.length"
                unit="articleSTNTaboola"
                :stn-page="stnPage"
                :is-stn-active="isStnActive"
              />
            </div>
          </div>
          <aside v-if="!isMobile" class="hidden sm:block flex-shrink-0 w-[345px] mt-4">
            <ArticleRecommendations v-if="!isEmpty(article)" :item="article" :latest-articles="sidebarRecommendations" />
          </aside>
        </div>
        <!--stn articles-->
        <div v-if="stnData.length > 0">
          <div v-for="stn_article in stnArticleList" :key="stn_article._id" class="flex flex-row">
            <div class="sm:flex-shrink-0 w-full max-w-[715px] mr-0 sm:mr-10">
              <AdController unit="StnMasthead" />
              <OArticle
                v-if="!isEmpty(stn_article) && isTestArticleReady"
                :item="stn_article"
                :stn-page="stnPage"
                :hide="['shareCount', 'viewCount']"
                @stn-impression="stnImpression"
                @oet-impression="sendOnedioEvent"
              ></OArticle>
              <LazyHydrate v-if="!isEmpty(stn_article)" never>
                <TrackingCodes :item="stn_article" />
              </LazyHydrate>
              <LazyHydrate v-if="hasFlag('showReactions')" :when-visible="{ rootMargin: '100px' }">
                <OArticleReactions class="mt-10 mb-6" :item="stn_article"></OArticleReactions>
              </LazyHydrate>
              <LazyHydrate v-if="hasFlag('showComments')" :when-visible="{ rootMargin: '300px' }">
                <OArticleComments :id="'reactions-' + stn_article.legacyId" class="mb-6" :item="stn_article"></OArticleComments>
              </LazyHydrate>
              <LatestWidget v-if="isMobile" :articles="sidebarRecommendations" class="px-4" />
              <!--stn arası taboola-->
              <div class="sm:px-3 px-2.5">
                <AdController v-if="stnPage < stnData.length" unit="articleSTNTaboola" :stn-page="stnPage" :is-stn-active="isStnActive" />
              </div>
            </div>
            <aside v-if="!isMobile" class="hidden sm:block flex-shrink-0 w-[345px] mt-4">
              <ArticleRecommendations v-if="!isEmpty(stn_article)" :item="stn_article" :latest-articles="sidebarRecommendations" />
            </aside>
          </div>
          <div ref="infiniteScrollRef"></div>
          <LoadMore v-if="showLoadMoreButton" class="sm:pl-14 sm:pr-5" :loading="loading" @click="loadMoreArticle" />
        </div>
        <AdController unit="pageskinLeft" class="absolute right-full top-0 mr-2.5 h-full" />
        <AdController unit="pageskinRight" class="absolute left-full top-0 ml-2.5 h-full" />
        <AdController unit="bodyBottom" />
        <AdController unit="interstitialPaid" />
        <Taboola v-if="!hasTaboolaConfig" mode="nowidget" class="taboola-no-widget" />
      </div>
    </div>
  </FullPageLayout>
</template>

<script>
import OArticle from '@/modules/article/components/OArticle.vue';
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout.vue';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
import TrackingCodes from '@/modules/tracking/components/TrackingCodes';
import {
  defineComponent,
  ref,
  useContext,
  useFetch,
  useMeta,
  useRoute,
  onMounted,
  onUnmounted,
  computed,
  ssrRef,
  watch,
  nextTick,
  inject,
} from '@nuxtjs/composition-api';
import { isEmpty, throttle } from 'lodash';
import AdController from '@/modules/ads/components/AdController';
import LazyHydrate from 'vue-lazy-hydration';
import { initializeAdLoaders } from '@/modules/ads/adUtils';
import OBackButton from '@/modules/common/components/ui/OBackButton/OBackButton';
import OArticleNavigator from '@/modules/common/components/ui/OArticleNavigator/OArticleNavigator';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import LatestWidget from '@/modules/article/components/LatestWidget';
import ArticleAds from '~/modules/article/components/ArticleAds.vue';
import { useDevice } from '~/composables/useDevice';
import { useArticleMeta } from '~/modules/article/utils/articleMeta';
import {
  articleTitle,
  getArticleWordCount,
  hasQuestion,
  getArticleCategoryPathNames,
  isVideoArticle,
} from '~/modules/article/utils/articleUtils';
import ArticleStatus from '~/modules/article/components/ArticleStatus';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { useInfiniteScroll } from '~/composables/useInfiniteScroll';
import LoadMore from '~/modules/feed/components/LoadMore';
import { getReadStatus, setReadStatus } from '~/modules/article/utils/stnUtils';
import { initQuiz } from '~/modules/quiz/utils/initQuiz';
import { useAuth } from '~/modules/auth/state/useAuth';
import ArticleIGWidget from '~/modules/article/components/ArticleIGWidget';
import ArticleFavorite from '~/modules/article/components/sticky/ArticleFavorite';
import ArticleShare from '~/modules/article/components/sticky/ArticleShare';
import ScrollToComments from '~/modules/common/components/app/layout/ScrollToComments';
import { LINK_PROD, SPONSORED, IS_ONEDIO, LANG } from '~/constants/config';
import { eventBus } from '~/modules/common/utils/eventBus';
import { generateGA4Article } from '~/modules/tracking/scripts/dataLayer';
import { getLegacyId } from '~/modules/common/utils/stringUtils';

export default defineComponent({
  middleware: 'articleRedirect',
  components: {
    ArticleIGWidget,
    LoadMore,
    LazyHydrate,
    FullPageLayout,
    ArticleFavorite,
    ScrollToComments,
    ArticleShare,
    OArticle,
    AdController,
    ArticleAds,
    ArticleRecommendations: () =>
      import(/* webpackChunkName: "ArticleRecommendations" */ '@/modules/common/components/article/ArticleRecommendations'),
    OBackButton,
    OArticleNavigator,
    // lazy-hydration kütüphanesindeki `hydrateWhenVisible` fonksiyonunu kullanmadik çünkü lazy load edilen component'ın classları ve proplarında sorun oluyor.
    // <LazyHydrate when-visible> component'ı daha sağlıklı çalışıyor.
    OArticleComments: () => import(/* webpackChunkName: "ArticleComments" */ '~/modules/article/components/OArticleComments.vue'),
    OArticleReactions: () => import(/* webpackChunkName: "ArticleReactions" */ '~/modules/article/components/OArticleReactions.vue'),
    VideoHero: () => import(/* webpackChunkName: "VideoHero" */ '~/modules/videoPage/VideoHero'),
    ArticleStatus,
    TrackingCodes,
    ErrorPageLayout,
    LatestWidget,
    Taboola: () => import(/* webpackChunkName: "taboola" */ '~/modules/ads/components/Taboola.vue'),
  },
  head: {
    bodyAttrs: { class: 'o-ps-global' },
  },
  layout: 'error',
  setup() {
    const { generateAdConfig } = initializeAdLoaders();
    const serversideAdConfig = generateAdConfig('Article');
    const { $service, $redirect, $error, $oet, i18n, $cache, $cookies } = useContext();
    const { isMobile, isInstagram, isBot } = useDevice();
    const { user, isLoggedIn } = useAuth();
    const route = useRoute();
    const slug = route.value.params.slug;
    const query = route.value.query;
    const articleId = parseInt(slug?.split('-').pop());
    const isSponsored = ssrRef(false);
    const article = ref({});
    const sidebarRecommendations = ref([]);
    const isStnActive = ssrRef(false);
    const stnData = ref([]);
    const stnArticleList = ref([]);
    const stnArticle = ref({});
    const stnPage = ref(0);
    const isTest = ref(false);
    const isHasJquery = ref(false);
    const isIgWidgetActive = ref(false);
    const hasTaboolaConfig = ref(false);
    const isChaptaActive = ref(false);
    const hasVitrinMdznEntry = ref(false);

    // STN'den gelen bir test olduğunda jquery'i dinamik olarak yüklüyor.
    useMeta(() => {
      return {
        script: [
          {
            hid: 'jquery',
            src: 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js',
            async: true,
            callback: () => {
              isHasJquery.value = true;
              eventBus.emit('load-jquery');
            },
            skip: !isTest.value,
          },
          {
            hid: 'turnstile',
            src: 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback',
            defer: true,
            skip: !isChaptaActive.value,
          },
          {
            hid: 'mdzn-widget',
            src: 'https://sdk.mdzn.io/widget/main.js',
            async: true,
            skip: !hasVitrinMdznEntry.value,
          },
        ],
      };
    });

    const { fetch, fetchState } = useFetch(async () => {
      try {
        if (!articleId || isNaN(articleId)) {
          $error('No legacy id passed', 404, false);
        }

        const { data } = await $service.article.getArticle(articleId);

        // stn shown cases
        const category = data?.categories?.find((cat) => cat.parent === undefined)?.name || '';
        const isAdultTags = data?.tags.some((tag) => ['+18', '#seks', '#cinsellik', '#+18', 'cinsellik', 'seks'].includes(tag));
        const isStnCategory = ['Finans', 'Magazin', 'Teknoloji', 'Goygoy'].includes(category);
        isStnActive.value = !isAdultTags && (isSponsored.value || isStnCategory) && !isDraft.value;

        article.value = { ...data, isStn: false, isStnActive: isStnActive.value };
        $cache(data?.flags?.isDraft ? 'no-cache' : 'public, max-age=60');
        isTest.value = hasQuestion(data);
        const adConfig = serversideAdConfig(article);
        const isPremiumUser = article.value.tags?.includes('Premium User');
        isChaptaActive.value = article.value.tags?.includes('~poll-security-check');
        hasVitrinMdznEntry.value = article.value.entries?.some((entry) => entry?.metadata?.product_html);

        if (!isPremiumUser) {
          const {
            data: { sidebar },
          } = await $service.article.getArticleSidebarRecommendations(articleId, {
            type: adConfig.value?.sponsoredTag?.type,
            sponsoredId: adConfig.value?.sponsoredTag?.id,
            limit: 5,
          });
          sidebarRecommendations.value = sidebar?.slice(0, 4);
        }
        if (article.value?.segments.some((segment) => segment.endsWith('Philips Category Branded'))) {
          const { data } = await $service.article.getSegmentsAudienceID(article.value?.segments);
          article.value.segmentsID = data;
        }
        isSponsored.value = adConfig.value?.decidedMode?.value === 'sponsored';
        hasTaboolaConfig.value = adConfig.value?.mode?.scripts?.includes('Taboola');
        // redirect to url
        if (article.value?.redirectUrl) {
          $redirect(article.value);
        }
      } catch (error) {
        // article check
        $error(error);
      }
    });

    // vue2+compositionapi template kısmında optional chaining kullanılmıyor
    const hasFlag = (flag) => article.value?.flags?.[flag] || false;
    const isDraft = computed(() => article.value?.flags?.isDraft || false);
    const isTestArticleReady = computed(() => {
      if (isTest.value) {
        return process.client && !!window?.jQuery;
      }
      return true;
    });

    // article sharer
    const shareArticle = ref({});
    const scrollListener = () => {
      document.onscroll = throttle(() => {
        if (!article.value) return;
        // set current article on screen
        const path = window.location.href;
        const legacyId = getLegacyId(path);
        const id = shareArticle.value?.legacyId || article.value?.legacyId;
        if (id !== legacyId && isStnActive.value && stnArticleList.value.length > 0) {
          shareArticle.value = stnArticleList.value.find((item) => item.legacyId === legacyId) || article.value;
        }
      }, 200);
    };

    const scrollToComments = () => {
      window.onNuxtReady(() => {
        if (route.value.query?.sc === 'true') {
          const target = document.getElementById('reactions-' + article.value.legacyId);
          window.scrollTo({ top: target?.getBoundingClientRect().top + window.pageYOffset - 100, behavior: 'smooth' });
        }
      });
    };

    onMounted(async () => {
      shareArticle.value = article.value;
      // listener for article sharer
      scrollListener();
      scrollToComments();
      // update url path with originalTitle
      if (!isEmpty(article.value) && article.value.title !== article.value.originalTitle) {
        const articleUrl = getArticleUrl({ article: article.value, query });
        history.replaceState({}, null, articleUrl);
      }

      // scroll to entry section
      if (query?.entry && document.getElementById(query?.entry)) {
        document.getElementById(query?.entry).scrollIntoView();
      }

      // instagram widget active case
      const referrer = computed(() => {
        if (process.client && history.length > 1 && document.referrer) {
          return document.referrer.split('/').pop();
        }
        return '/';
      });
      isIgWidgetActive.value = isMobile.value && (referrer.value === 'instagram' || isInstagram.value);

      // get stn articles
      if (isStnActive.value) {
        try {
          const categoryId = article.value?.categories?.find((cat) => cat.parent === undefined)?._id;
          const tagId = article.value?.badges[0]?._id;
          if (categoryId) {
            const params = { id: articleId, deviceType: isMobile.value ? 'mobile' : 'desktop' };
            if (isSponsored.value && tagId) {
              params.tagId = tagId;
            } else {
              params.categoryId = categoryId;
            }
            const response = await $service.article.getSTNArticles(params);
            if (response.data) {
              const filteredSTNArticles = response.data.filter((article) => {
                // kullanıcı içeriği daha önce okudu mu?
                const isUserReadArticle = getReadStatus(article);
                return !(isUserReadArticle || !article?._id);
              });
              // manuel test yapılabilmesi için query
              if (query && query['stn-test']) {
                query['stn-test'].split(',').map((item) => {
                  filteredSTNArticles.unshift({
                    _id: item,
                  });
                });
              }
              stnData.value = filteredSTNArticles;
              // simple stn eklentisi için eklendi
              window.stnList = filteredSTNArticles;
            }
          }
        } catch (error) {
          $error(error);
        }
      }
    });

    const getSTNArticle = async (callback) => {
      try {
        if (stnPage.value > stnData.value.length - 1) return;
        const currentStnArticle = stnData.value[stnPage.value];

        const { data } = await $service.article.getArticle(currentStnArticle?._id);
        isTest.value = hasQuestion(data);
        stnArticle.value = { ...data, isStn: true, isStnActive: isStnActive.value };
        sendPageView(data, true, isLoggedIn.value);
        if (stnArticle.value?._id) {
          stnArticleList.value.push(stnArticle.value);
          document.title = stnArticle.value?.title || i18n.t('news-page.no-content');
          stnPage.value++;
          loading.value = false;
          if (callback) {
            await nextTick();
            watch(
              isTestArticleReady,
              (isArticleReady) => {
                if (isArticleReady) {
                  callback();
                }
              },
              { immediate: true }
            );
          }
        }
      } catch (error) {
        stnPage.value++;
        await getSTNArticle();
        $error(error);
      }
    };

    const stnImpression = (article, isLoggedIn) => {
      // SRV Hit & PageView for STN
      const articleRef = ref(article);
      sendOnedioSRVHit(articleRef);
      sendOnedioEvent('item_read', articleRef, true);
      sendPageView(articleRef, true, isLoggedIn);

      const currentStnArticle = stnData.value[stnPage.value - 1];
      sendOnedioPanelCounter(currentStnArticle?.url);
      // set article read status
      setReadStatus(currentStnArticle);
    };

    const loading = ref(false);
    const loadMoreArticle = () => {
      loading.value = true;
      getSTNArticle();
    };

    // her 3 içerikten sonra infinite scroll yerine load more butonu gelsin
    const showLoadMoreButton = computed(() => stnPage.value < stnData.value.length && (stnArticleList.value.length + 1) % 3 === 0);

    const [infiniteScrollRef] = useInfiniteScroll(
      () => {
        if (showLoadMoreButton.value) return;
        getSTNArticle();
      },
      { rootMargin: '600px' }
    );

    useMeta(() => ({ title: articleTitle(article.value, isBot.value) || i18n.t('news-page.no-content') }));

    // ------- Google Pageview Event Beginning -------
    const { sendPageviewEvent, sendArticleRefTags, sendOnedioSRVHit, sendOnedioPanelCounter, sendArticleHashtags } = useTracking();
    const sendPageView = (article, isSTN, isLoggedIn) => {
      sendPageviewEvent(
        () => ({
          event: isSTN ? 'vPageView' : 'PageView',
          page: {
            name: article.value?.title || i18n.t('news-page.no-content'),
            type: 'Haber Detay',
          },
          content: {
            category1: article.value?.breadcrumb?.[0]?.name || '',
            category2: article.value?.breadcrumb?.[1]?.name || '',
            category3: article.value?.breadcrumb?.[2]?.name || '',
            name: article.value?.title || i18n.t('news-page.no-content'),
            id: article.value?.legacyId,
            editor: article.value?.authors?.[0]?.username || '~no-username',
            date: article.value?.dates?.published?.slice(0, 10),
            tags: article.value?.tags || [],
            refTags: article.value?.refTags?.map((v) => v.name),
            isSponsored: SPONSORED.some((i) => article.value?.tags?.includes(i)),
            isScrollToNext: isSTN ? 1 : 0,
            entryCount: article.value?.entries?.length,
            segments: article.value?.segmentsID || '',
            isSponsoredCategory: isSponsored.value ? 1 : 0,
            ...(getArticleCategoryPathNames(article.value)?.[1] && { subcategory1: getArticleCategoryPathNames(article.value)?.[1] }),
            ...(getArticleCategoryPathNames(article.value)?.[2] && { subcategory2: getArticleCategoryPathNames(article.value)?.[2] }),
          },
        }),
        [article],
        isLoggedIn
      );
      sendArticleRefTags(() => article.value?.refTags, [article]);
      sendArticleHashtags(() => article.value?.hashtags, [article]);
    };

    const sendOnedioEvent = (eventType, article, isSTN = false) => {
      if (isEmpty(article.value)) return;
      $oet.pushEvent({
        userId: user.value?._id,
        eventType,
        itemId: article.value?.legacyId?.toString(),
        itemType: 'article',
        itemMetadata: {
          _id: article.value?._id,
          legacyId: article.value?.legacyId,
          title: article.value?.title,
          image: article.value?.image,
          editor: article.value?.authors?.[0]?.username || '~no-username',
          categories: article.value?.categories?.map((cat) => cat.name) || [],
          tags: article.value?.tags || [],
          entryCount: article.value?.entries?.length,
          wordCount: getArticleWordCount(article.value),
          description: article.value?.description,
          entryTypes: article.value?.entries?.map((entry) => entry?.mode) || [],
          stats: article.value?.stats,
          reactions:
            article.value?.reactions?.map((reaction) => {
              return { count: reaction.count, id: reaction.id };
            }) || [],
          flags: article.value?.flags,
          dates: article.value?.dates,
          keywords: article.value?.keywords,
          seoData: article.value?.seoData || {},
          isSponsored: SPONSORED.some((i) => article.value?.tags?.includes(i)),
          isScrollToNext: isSTN,
          url: LINK_PROD + article.value.route,
        },
      });
    };

    sendPageView(article);

    onMounted(() => {
      if (isChaptaActive.value) {
        /* eslint-disable */
        turnstile.render('#cfct-container', {
          sitekey: '0x4AAAAAAA2Swquu9WwfaZ73',
          language: LANG,
          theme: 'light',
          callback: function (token) {
            sendOnedioSRVHit(article, token);
            $cookies.set('o-cfct', token);
            document.getElementById('verification-modal')?.classList.add('invisible');
            document.body.classList.remove('no-scroll');
          },
          'before-interactive-callback': function () {
            document.body.classList.add('no-scroll');
            document.getElementById('verification-modal')?.classList.remove('invisible');
          },
        });
      } else {
        sendOnedioSRVHit(article);
      }
      sendOnedioEvent('item_read', article);
      const adConfig = inject('adConfig');
      window.dataLayer.push({
        ecommerce: null,
      });
      window.dataLayer.push({
        event: 'view_item', // Sabit olarak bu değer yazılmalıdır.
        ecommerce: {
          items: [generateGA4Article({ article: article.value, adConfig })],
        },
      });
    });

    onUnmounted(() => {
      // delete cfct cookie after page is unmounted
      $cookies.remove('o-cfct');
    });

    watch([isHasJquery, stnArticle], ([isHasJqueryNew]) => {
      if (isHasJqueryNew) initQuiz(stnArticle.value, false);
    });

    const isOnedioVideo = computed(() => isVideoArticle(article));

    // ------- Google Pageview Event End -------

    useArticleMeta({ article, isBot: isBot.value });

    return {
      article,
      isEmpty,
      isMobile,
      isDraft,
      isOnedioVideo,
      isTestArticleReady,
      fetchState,
      fetch,
      hasFlag,
      sidebarRecommendations,
      infiniteScrollRef,
      stnArticleList,
      loading,
      loadMoreArticle,
      showLoadMoreButton,
      stnImpression,
      stnData,
      stnPage,
      shareArticle,
      isIgWidgetActive,
      sendOnedioEvent,
      isStnActive,
      hasTaboolaConfig,
      IS_ONEDIO,
      isChaptaActive,
      hasVitrinMdznEntry,
    };
  },
});
</script>

<style lang="scss"></style>
